import { useCommunityContext } from '@/providers/community-context';
import { EventsPageShell } from '@/pages/events/components/EventsPageShell';
import { MembersView } from './members-view';
import { Loader2 } from 'lucide-react';

export default function MembersPage() {
  const { community: currentCommunity, isLoading } = useCommunityContext();

  if (isLoading) return <Loader2 className="h-8 w-8 animate-spin text-primary mx-auto mt-12" />;
  if (!currentCommunity) return null;

  return (
    <EventsPageShell>
      <MembersView communityId={currentCommunity.id} />
    </EventsPageShell>
  );
}
